import React, { useEffect, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { PageSpinner } from 'shared-components/decorators/spinner';
import { Listings } from '../../../api/api-listings';
import { Spaces } from '../../../api/api-spaces';
import { Tabs } from '../elements-buttons/tab-buttons';
import { ReviewsByYou } from './ReviewsByYou';
import { ReviewsOfSpace } from './ReviewsOfSpace';
import { ReviewsOfYou } from './ReviewsOfYou';
import { ReviewTabs } from './reviews-utils';

const ReviewsContainer = ({ profile, router, intl, accessToken }) => {
  const [userSpaces, setUserSpaces] = useState();
  const [reviewsOfYou, setReviewsOfYou] = useState({
    reviews: {},
    total: NaN,
  });
  const [reviewsOfSpace, setReviewsOfSpace] = useState({
    // [space._id]: {
    //   reviews: {},
    //   total: 0
    // }
  });
  const [reviewsByYou, setReviewsByYou] = useState({
    reviews: {},
    total: NaN,
  });

  const tabConfigs = [
    {
      link: 'reviews/about-you',
      label: intl.formatMessage({
        id: 'reviews.tabs.about_you',
        defaultMessage: 'About you as a guest',
      }),
    },
    {
      link: 'reviews/by-you',
      label: intl.formatMessage({
        id: 'reviews.tabs.by_you',
        defaultMessage: 'Written by you',
      }),
    },
  ];
  if (userSpaces?.length) {
    tabConfigs.splice(1, 0, {
      link: 'reviews/about-spaces',
      label: intl.formatMessage({
        id: 'reviews.tabs.about_spaces',
        defaultMessage: 'About your space',
      }),
    });
  }

  const fetchUserSpaces = (spaceIds) => {
    if (!spaceIds.length) {
      setUserSpaces([]);
    }
    Spaces.read(
      `owner/${profile.SSOid}?full=true&no_deactivated=true`,
      accessToken,
      (res) => {
        const activeSpaces = (res?.spaces || []).filter((s) =>
          spaceIds.includes(s._id)
        );
        setUserSpaces(activeSpaces);
      }
    );
  };

  useEffect(() => {
    if (!profile?.hasFetched) {
      return;
    }
    Listings.read(
      `owner/${profile.SSOid}?full=true&no_deactivated=true`,
      (res) => {
        const parentSpaceIds = new Set();
        const activeListings = (res?.listings || []).filter(
          (l) => l.status === 'ACTIVATED'
        );
        activeListings.forEach((l) => parentSpaceIds.add(l.parentSpaceId));
        fetchUserSpaces(Array.from(parentSpaceIds));
      }
    );
  }, [profile?.hasFetched]);

  useEffect(() => {
    const activeTab = router.params?.reviewTab;
    if (
      ![
        ReviewTabs.ABOUT_YOU,
        ReviewTabs.ABOUT_SPACES,
        ReviewTabs.BY_YOU,
      ].includes(activeTab)
    ) {
      router.replace(`/reviews/${ReviewTabs.ABOUT_YOU}`);
    }
  }, []);

  if (!profile?.hasFetched || !userSpaces) {
    return <PageSpinner additionalStyle='gray' />;
  }

  return (
    <div className='page'>
      <div className='ps-container-lg-margin ps-container-fixed'>
        <div className='ps-row'>
          <div className='col-xs-12'>
            <h1 className='h2 heading'>
              <FormattedMessage
                id='reviews_page.page_title'
                defaultMessage='Reviews'
              />
            </h1>
            <Tabs tabs={tabConfigs} isResponsive={true} />
            {router.params.reviewTab === ReviewTabs.ABOUT_YOU && (
              <ReviewsOfYou
                reviewsCache={reviewsOfYou}
                setReviewsCache={setReviewsOfYou}
                accessToken={accessToken}
                profile={profile}
                router={router}
              />
            )}
            {router.params.reviewTab === ReviewTabs.ABOUT_SPACES && (
              <ReviewsOfSpace
                reviewsCache={reviewsOfSpace}
                setReviewsCache={setReviewsOfSpace}
                accessToken={accessToken}
                router={router}
                userSpaces={userSpaces}
              />
            )}
            {router.params.reviewTab === ReviewTabs.BY_YOU && (
              <ReviewsByYou
                reviewsCache={reviewsByYou}
                setReviewsCache={setReviewsByYou}
                accessToken={accessToken}
                profile={profile}
                router={router}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ profile }) => ({ profile });

export default injectIntl(
  connect(mapStateToProps)(ReviewsContainer)
);
